var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrashcan = function SvgTrashcan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.9 3c0-1.7 1.3-3 3-3h2c1.7 0 3 1.3 3 3H17c.2 0 .5.2.5.4l.3 2c.1.3-.2.6-.5.6H2.5c-.3 0-.5-.3-.5-.6l.3-2c.1-.2.3-.4.5-.4h3.1zm2 0c0-.6.4-1 1-1h2c.6 0 1 .4 1 1h-4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 8.5.9 10c0 .3.2.5.5.5h11.1c.3 0 .5-.2.5-.5l.9-10c0-.3-.2-.5-.5-.5H3.5c-.3 0-.6.3-.5.5z"
  })));
};
export default SvgTrashcan;